// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__3zMuA","errors":"Errors_errors__1lbcR"};